// Link esterni reali (Hotmart)
export const LINKS = {
  hotmart: "https://go.hotmart.com/C106982853W?dp=1", // Corso: Torte Perfette Senza Stress
  ebookFattoria: "https://go.hotmart.com/R107044768K?dp=1", // Ebook: Biscotti senza stress — Animali della Fattoria
  ebookFamiglia: "https://go.hotmart.com/H107030018O?dp=1", // Ebook: Biscotti senza stress — Mamma, papà e i nonni
};

export const IMAGES = {
  hero: "/images/torta-40.jpg",
  torta40: "/images/torta-40.jpg",
  comunione: "/images/torta-comunione.jpg",
  matilde: "/images/torta-matilde.jpg",
  leo: "/images/torta-leo.jpg",
  insegnante: "/images/insegnante.jpg",
  giorgia: "/images/giorgia.jpg",
  biscotti: "/images/biscotti-unicorno.jpg",
  fattoria: "/images/fattoria.jpg",
  mamma: "/images/mamma.jpg",
  pupazzo: "/images/pupazzo.jpg",
  orsetto: "/images/orsetto.jpg",
  papa: "/images/papa.jpg",
  nonni: "/images/nonni.jpg",
  // Foto di repertorio (stock Unsplash) in attesa delle foto reali di Giorgia
  zucca: "https://images.unsplash.com/photo-1603320284194-db4276c54f0a?auto=format&fit=crop&w=1600&q=80",
  fantasmino: "https://images.unsplash.com/photo-1697378595024-e662aaacf914?auto=format&fit=crop&w=1200&q=80",
  streghetta: "https://images.unsplash.com/photo-1695295491706-bbcc803a1269?auto=format&fit=crop&w=1200&q=80",
  mare: "/images/mare.jpg",
  unicornoSettimana: "/images/unicorno-settimana.jpg",
  arcobaleno: "/images/arcobaleno.jpg",
  halloween: "/images/halloween.jpg",
  teschietto: "/images/teschietto.jpg",
  zucca3d: "/images/zucca-3d.jpg",
  pentolone: "/images/pentolone.jpg",
  // Immagine natalizia generica (stock Unsplash) in attesa dei tutorial di Natale
  nataleTeaser: "https://images.unsplash.com/photo-1511731357620-952d10f3234c?auto=format&fit=crop&w=1200&q=80",
  gufetto: "/images/gufetto.jpg",
  pecorella: "/images/pecorella.jpg",
  principe: "/images/principe.jpg",
  superLorenzo: "/images/super-lorenzo.jpg",
  superNicolo: "/images/super-nicolo.jpg",
  cookies: "https://images.unsplash.com/photo-1676628537728-d7715a8a897c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA8Mzl8MHwxfHNlYXJjaHwyfHxkZWNvcmF0ZWQlMjBzdWdhciUyMGNvb2tpZXMlMjBjYWtlJTIwZGVjb3JhdGluZyUyMHN1Z2FyJTIwcGFzdGUlMjBtb2RlbGluZ3xlbnwwfHx8fDE3ODk0Nzc2Njh8MA&ixlib=rb-4.1.0&q=85",
  cakeWhiteGold: "https://images.unsplash.com/photo-1629196256546-ff4f3e27f623?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxhcnRpc2FuJTIwY2FrZSUyMGRlY29yYXRpbmclMjBmb25kYW50JTIwZnJvc3RpbmclMjBiYWtlcnl8ZW58MHx8fHwxNzg5NDc3Njc2fDA&ixlib=rb-4.1.0&q=85",
  ingredients: "https://images.unsplash.com/photo-1588467850695-a898367ce465?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxiYWtpbmclMjBpbmdyZWRpZW50cyUyMGZsb3VyJTIwYnV0dGVyJTIwcm9sbGluZyUyMHBpbiUyMHBhc3RyeSUyMGRvdWdofGVufDB8fHx8MTc4OTQ3NzY3OXww&ixlib=rb-4.1.0&q=85",
  cakeBlue: "https://images.unsplash.com/photo-1574936423169-82494c75f01f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxhcnRpc2FuJTIwY2FrZSUyMGRlY29yYXRpbmclMjBmb25kYW50JTIwZnJvc3RpbmclMjBiYWtlcnl8ZW58MHx8fHwxNzg5NDc3Njc2fDA&ixlib=rb-4.1.0&q=85",
};

export const MARQUEE_ITEMS = [
  "Pasta di Zucchero",
  "Modellaggio 3D",
  "Pasta Frolla",
  "Cake Design",
  "Biscotti Decorati",
  "Pan di Spagna",
];

// Ricette base per 24 biscotti (ogni biscotto tondo pesa circa 27-30 g). round: g5 = grammi a passi di 5, half = mezze unità, tenth = decimi, fixed = invariato
export const FROLLA_VARIANTS = {
  classica: {
    label: "Classica (dal libro)",
    note: "La ricetta originale di «Biscotti Facili»: escono circa 24 biscotti da 27-30 g.",
    items: [
      { name: "Farina 00", qty: 350, unit: "g", round: "g5" },
      { name: "Burro freddo a pezzetti", qty: 150, unit: "g", round: "g5" },
      { name: "Zucchero a velo", qty: 120, unit: "g", round: "g5" },
      { name: "Uovo intero", qty: 1, unit: "", round: "half" },
      { name: "Tuorli", qty: 2, unit: "", round: "half" },
      { name: "Scorza di limone", qty: 1, unit: "di 1 limone", round: "fixed" },
    ],
  },
  cacao: {
    label: "Al Cacao Amaro",
    note: "Intensa e profumata, perfetta per i personaggi dal manto scuro.",
    items: [
      { name: "Farina 00", qty: 315, unit: "g", round: "g5" },
      { name: "Cacao amaro in polvere", qty: 35, unit: "g", round: "g5" },
      { name: "Burro freddo a pezzetti", qty: 150, unit: "g", round: "g5" },
      { name: "Zucchero a velo", qty: 130, unit: "g", round: "g5" },
      { name: "Uovo intero", qty: 1, unit: "", round: "half" },
      { name: "Tuorli", qty: 2, unit: "", round: "half" },
    ],
  },
  senzaGlutine: {
    label: "Senza Glutine",
    note: "Con mix di farine senza glutine: stessa friabilità, zero compromessi.",
    items: [
      { name: "Mix farine senza glutine", qty: 360, unit: "g", round: "g5" },
      { name: "Burro freddo a pezzetti", qty: 150, unit: "g", round: "g5" },
      { name: "Zucchero a velo", qty: 120, unit: "g", round: "g5" },
      { name: "Uovo intero", qty: 1, unit: "", round: "half" },
      { name: "Tuorli", qty: 2, unit: "", round: "half" },
      { name: "Scorza di limone", qty: 1, unit: "di 1 limone", round: "fixed" },
    ],
  },
};

export const FROLLA_STEPS = [
  { title: "Sabbiatura", text: "Unisci farina e zucchero a velo, aggiungi il burro freddo a pezzetti e lavora fino a ottenere un composto sabbioso." },
  { title: "Legante", text: "Unisci l'uovo intero, i tuorli e la scorza di limone. Impasta velocemente: meno lavori l'impasto, più i biscotti restano lisci." },
  { title: "Riposo", text: "Avvolgi il panetto nella pellicola e lascia riposare in frigo per almeno 30 minuti." },
  { title: "Cottura", text: "Stendi, ricava i biscotti con lo stampo tondo e cuoci in forno statico a 180°C per 12-14 minuti." },
];

export const BISCOTTO_SETTIMANA = {
  nome: "Pentolone della Strega",
  sottotitolo: "Il personaggio più scenografico di Halloween: un pentolone nero che ribolle di bollicine verdi, tra pipistrello e occhietto sorpreso",
  testo: "Il tutorial è gratuito, facile e ci vogliono circa 20 minuti: accendi il video e crea il tuo pentolone insieme a Giorgia, bolla dopo bolla. Nessuna fretta e nessun passaggio complicato: solo pasta di zucchero e tanta allegria.",
  difficolta: "Facile",
  tempo: "20 minuti",
  tema: "Speciale Halloween",
  tagline: "bolle, bolle... magia!",
  image: "pentolone",
  hook: "Halloween volge al termine... ma la magia continua: a breve arrivano i tutorial di Natale, tra pupazzi di neve e dolci decorazioni bianche e rosse!",
  steps: [],
};

export const TECNICHE_CARDS = [
  { icon: "Layers", title: "Dummies in Polistirolo", text: "Come foderare le basi finte con pasta da copertura: misura, stendi, liscia. Zero sprechi, prove infinite." },
  { icon: "Candy", title: "La Pasta di Zucchero giusta", text: "Quale pasta di zucchero uso io, sia per modellare che per decorare: come sceglierla senza sbagliare." },
  { icon: "Wand2", title: "Ball Tool & Smoother", text: "Ball tool e smoother: assottigliare i dettagli e lisciare le coperture come una professionista." },
  { icon: "Palette", title: "Quali sono i coloranti migliori?", text: "Gel, polveri o idrosolubili: quali coloranti scegliere e come dosarli senza sprechi." },
];

export const CORSO_INCLUDE = [
  "1 ora e mezza di corso, da vedere con calma",
  "5 moduli passo-passo da seguire ai tuoi ritmi",
  "Lista completa dei materiali",
  "Schede tecniche da scaricare",
  "Accesso a vita",
];

export const CATALOG_ITEMS = [
  { id: "orsetto", title: "Orsetto Teddy", cat: "Biscotti 3D", free: true, image: "orsetto", pos: "object-[50%_38%]", tutorial: "https://www.youtube.com/watch?v=D7u1tq9vYTY" },
  { id: "unicorno", title: "Unicorno Kawaii", cat: "Biscotti 3D", free: true, image: "unicornoSettimana", pos: "object-[50%_55%]", tutorial: "https://youtu.be/FRVGFVdgyYM" },
  { id: "gufetto", title: "Gufetto", cat: "Personaggi", free: true, image: "gufetto", pos: "object-[50%_42%]", tutorial: "https://youtu.be/rH3U1WpZor4" },
  { id: "pecorella", title: "Pecorella", cat: "Personaggi", free: true, image: "pecorella", pos: "object-[50%_55%]", tutorial: "https://youtu.be/OqmFY6GFkkk" },
  { id: "arcobaleno", title: "Biscotto Arcobaleno", cat: "Biscotti 3D", free: true, image: "arcobaleno", pos: "object-[50%_42%]", tutorial: "https://youtu.be/7L1qEtgRtIQ" },
  { id: "fattoria", title: "Animali della Fattoria", cat: "Biscotti 3D", free: false, image: "fattoria", link: LINKS.ebookFattoria },
  { id: "mamma", title: "W la Mamma!", cat: "Biscotti 3D", free: false, image: "mamma", link: LINKS.ebookFamiglia },
  { id: "papa", title: "W il Papà!", cat: "Biscotti 3D", free: false, image: "papa", link: LINKS.ebookFamiglia },
  { id: "nonni", title: "W i Nonni!", cat: "Biscotti 3D", free: false, image: "nonni", link: LINKS.ebookFamiglia },
  { id: "zucca3d", title: "Zucca 3D di Halloween", cat: "Personaggi 3D", free: true, image: "zucca3d", pos: "object-[50%_42%]", tutorial: "https://youtu.be/JyoTQrmfcQQ" },
  { id: "pentolone", title: "Pentolone della Strega", cat: "Personaggi 3D", free: true, image: "pentolone", pos: "object-[50%_52%]", tutorial: "https://youtu.be/wr0hjdFn8OE" },
  {
    id: "natale",
    title: "Tutorial di Natale",
    cat: "Novità",
    free: false,
    teaser: true,
    teaserText: "A breve i tutorial di Natale!",
    image: "nataleTeaser",
  },
];

// Ricetta originale estratta dal libro «Biscotti Facili — Famiglia»
export const PASTA_ZUCCHERO = {
  ingredients: [
    "500 g di zucchero a velo",
    "5 g di gelatina in fogli (o 2 cucchiaini in polvere)",
    "30 g di acqua",
    "50 g di glucosio liquido (oppure miele)",
    "10 g di burro",
    "1 cucchiaino di glicerina (facoltativa, per una pasta più morbida)",
    "Coloranti alimentari, meglio in gel",
  ],
  steps: [
    "Metti la gelatina in ammollo nell'acqua per 10 minuti, poi scioglila a bagnomaria o al microonde.",
    "Aggiungi glucosio (o miele) e burro alla gelatina sciolta e mescola finché il composto è omogeneo.",
    "Versa lo zucchero a velo in una ciotola, fai un buco al centro e incorpora il composto con una spatola.",
    "Quando diventa difficile mescolare, impasta con le mani fino a una consistenza liscia ed elastica.",
    "Colora con poche gocce di colorante gel e impasta finché il colore è uniforme.",
    "Conserva in pellicola trasparente: qualche giorno a temperatura ambiente, fino a 2 settimane in frigo.",
  ],
};

export const ARCHIVIO_BISCOTTI = [
  {
    id: "orsetto",
    title: "Orsetto Teddy",
    text: "L'orsetto con il fiocchetto azzurro: il primo personaggio 3D di tante pasticcione.",
    image: "orsetto",
    alt: "Orsetto Teddy modellato a mano in pasta di zucchero",
    pos: "object-[50%_38%]",
    cta: "Guarda il tutorial gratuito",
    link: "https://www.youtube.com/watch?v=D7u1tq9vYTY",
  },
  {
    id: "scheletrino",
    title: "Scheletrino di Halloween",
    text: "Occhioni a fagiolo e bocca cucita con lo spaghetto: lo scheletrino più simpatico di Halloween.",
    image: "teschietto",
    alt: "Biscotto Scheletrino di Halloween decorato in pasta di zucchero",
    pos: "object-[50%_50%]",
    cta: "Guarda il tutorial gratuito",
    link: "https://youtu.be/Q-2dZm4oFug",
  },
  {
    id: "arcobaleno",
    title: "Biscotto Arcobaleno",
    text: "Archi pastello, nuvolette e stelline dorate: l'arcobaleno più dolce che ci sia.",
    image: "arcobaleno",
    alt: "Biscotto Arcobaleno decorato in pasta di zucchero su marmo con lavanda",
    pos: "object-[50%_42%]",
    cta: "Guarda il tutorial gratuito",
    link: "https://youtu.be/7L1qEtgRtIQ",
  },
  {
    id: "unicorno",
    title: "Unicorno Kawaii",
    text: "Corno dorato, orecchie e occhioni sognanti: l'unicorno più dolce che ci sia.",
    image: "unicornoSettimana",
    alt: "Biscotto Unicorno Kawaii decorato in pasta di zucchero su marmo",
    pos: "object-[50%_55%]",
    cta: "Guarda il tutorial gratuito",
    link: "https://youtu.be/FRVGFVdgyYM",
  },
  {
    id: "fattoria",
    title: "Animali della Fattoria",
    text: "Cavallo, mucca e maialino: tutta la fattoria da un semplice biscotto tondo.",
    image: "fattoria",
    alt: "Biscotti decorati a forma di cavallo, mucca e maialino in pasta di zucchero",
    cta: "Guida nell'Ebook Fattoria",
    link: LINKS.ebookFattoria,
  },
  {
    id: "mamma",
    title: "W la Mamma!",
    text: "Il viso dolce della mamma, con occhioni espressivi e sorriso rosa.",
    image: "mamma",
    alt: "Biscotto decorato a forma di viso di mamma in pasta di zucchero",
    cta: "Guida nell'Ebook Famiglia",
    link: LINKS.ebookFamiglia,
  },
  {
    id: "papa",
    title: "W il Papà!",
    text: "Capelli scuri e sorriso furbo: il papà in versione biscotto.",
    image: "papa",
    alt: "Biscotto decorato a forma di viso di papà in pasta di zucchero",
    cta: "Guida nell'Ebook Famiglia",
    link: LINKS.ebookFamiglia,
  },
  {
    id: "nonni",
    title: "W i Nonni!",
    text: "Nonna e nonno insieme: la coppia più dolce di tutta la famiglia.",
    image: "nonni",
    alt: "Biscotti decorati a forma di nonna e nonno in pasta di zucchero",
    cta: "Guida nell'Ebook Famiglia",
    link: LINKS.ebookFamiglia,
  },
];

export const YOUTUBE = {
  videoId: "wr0hjdFn8OE",
  gufettoId: "rH3U1WpZor4",
  watch: "https://youtu.be/wr0hjdFn8OE",
  channel: "https://www.youtube.com/@leallegrepasticcione",
};

export const SOCIALS = [
  { id: "instagram", label: "Instagram — Giorgia Perletta", href: "https://www.instagram.com/giorgiaperletta/" },
  { id: "facebook", label: "Facebook — Giorgia Perletta", href: "https://www.facebook.com/giorgia.perletta" },
  { id: "facebook-page", label: "Facebook — Le Allegre Pasticcione", href: "https://www.facebook.com/LeAllegrePasticcione/" },
  { id: "youtube", label: "YouTube — Le Allegre Pasticcione", href: "https://www.youtube.com/@leallegrepasticcione" },
];

export const TORTE_GALLERY = [
  { id: "torta40", image: "torta40", title: "Torta «40» Rosa e Oro", occasion: "Quarantesimo compleanno" },
  { id: "nicolo", image: "superNicolo", title: "Super Mario", occasion: "I 4 anni di Nicolò", pos: "object-[50%_60%]" },
  { id: "comunione", image: "comunione", title: "Comunione & Cresima", occasion: "Francesco e Tommaso" },
  { id: "lorenzo", image: "superLorenzo", title: "Mario & Luigi", occasion: "Super Lorenzo", pos: "object-[50%_30%]" },
  { id: "leo", image: "leo", title: "Leone & Scimmietta", occasion: "Il primo compleanno di Leo", pos: "object-[50%_62%]" },
  { id: "federico", image: "principe", title: "Il Piccolo Principe", occasion: "Benvenuto Federico", pos: "object-[50%_62%]" },
  { id: "matilde", image: "matilde", title: "Cavalluccio a Dondolo", occasion: "Benvenuta Matilde", pos: "object-[50%_68%]" },
  { id: "mare", image: "mare", title: "Fondo del Mare", occasion: "Il primo compleanno di G.", pos: "object-[50%_62%]" },
];

export const BASI_TORTE = [
  {
    id: "pan-di-spagna",
    calc: true,
    baseSize: 20,
    title: "Pan di Spagna",
    subtitle: "La base classica · ricetta gratuita · dosi calcolate sulla tua teglia",
    items: [
      { name: "Uova", qty: 300, unit: "g", round: "g5" },
      { name: "Zucchero", qty: 200, unit: "g", round: "g5" },
      { name: "Farina 00 setacciata", qty: 200, unit: "g", round: "g5" },
      { name: "Lievito per dolci", qty: 8, unit: "g", round: "half" },
      { name: "Scorza di limone edibile", qty: 1, unit: "di 1 limone", round: "fixed" },
    ],
    steps: [
      "Trita lo zucchero con la scorza di limone fino a ottenere uno zucchero a velo profumato.",
      "Sbatti le uova con lo zucchero aromatizzato finché il composto è chiaro e spumoso.",
      "Incorpora farina e lievito setacciati insieme, dal basso verso l'alto.",
      "Versa nella teglia e cuoci in forno statico a 170°C per 30-35 minuti.",
    ],
    note: "non aprire il forno nei primi 25 minuti!",
  },
  {
    id: "moretto",
    locked: true,
  },
];
